module.exports = __webpack_public_path__ + "static/media/requestPhone.38f0e025.svg";